// import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import "./single.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { Link } from "react-router-dom";
// import { serverUrl } from "../../temp";
// const ExaminationSingle = () => {
//   // Extracting examinationId using regular expressions
//   const location = useLocation();
//   // const examinationId = location.pathname.match(/\/examination\/(\d+)/);
//   const examinationId = location.pathname.match(/\/examinations\/(\d+)/)?.[1];
//   console.log("abbasexam", examinationId);
//   const [examination, setExamination] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const fetchExamination = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/examination/${examinationId}`);
//       // if (!response.ok) {
//       //     throw new Error('Failed to fetch User');
//       // }
//       const data = await response.json();
//       setExamination(data);
//       localStorage.setItem("UserData", JSON.stringify(data));
//     } catch (error) {
//       console.error(error);
//     }
//   };
//   const isPdf = (url) => {
//     return url?.toLowerCase().endsWith(".pdf");
//   };

//   useEffect(() => {
//     if (examinationId) {
//       fetchExamination();
//     }
//   }, [examinationId]);

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="single">
//           <Sidebar />
//           <div className="singleContainer">
//             <Navbar />
//             <div className="top">
//               <div className="left">
//                 <h1 className="title">Exam Information</h1>
//                 <div className="item">
//                   {isPdf(examination?.data.file_url) ? (
//                     <img
//                       src="/images/pdf_icon.png" // Assuming your pdf icon is saved in public folder as "pdf-icon.png"
//                       alt="Paper PDF"
//                       className="itemImg"
//                     />
//                   ) : (
//                     <img
//                       src={examination?.data.file_url}
//                       alt="Paper Image"
//                       className="itemImg"
//                     />
//                   )}
//                   <div className="details">
//                     {/* <h1 className="itemTitle">{examination?.data.name}</h1> */}
//                     <div className="detailItem">
//                       <span className="itemKey">Paper: </span>
//                       <span className="itemValue">
//                         {examination?.data.file}
//                       </span>
//                     </div>
//                     {/* <div className="detailItem">
//                                             <span className="itemKey">Center Id: </span>
//                                             <span className="itemValue">{examination?.data.center_id}</span>
//                                         </div> */}
//                     <div className="detailItem">
//                       <span className="itemKey">Class: </span>
//                       <span className="itemValue">
//                         {examination?.data.class_names}
//                       </span>
//                     </div>
//                     <div className="detailItem">
//                       <span className="itemKey">Subject: </span>
//                       <span className="itemValue">
//                         {examination?.data.subject_names}
//                       </span>
//                     </div>
//                     <div className="detailItem">
//                       <span className="itemKey">Paper Type: </span>
//                       <span className="itemValue">
//                         {examination?.data.type}
//                       </span>
//                     </div>
//                     <div className="detailItem">
//                       <span className="itemKey">Month: </span>
//                       <span className="itemValue">
//                         {examination?.data.month}
//                       </span>
//                     </div>
//                     <div className="detailItem">
//                       <span className="itemKey">Date: </span>
//                       <span className="itemValue">
//                         {examination?.data.date}
//                       </span>
//                     </div>
//                     <div className="detailItem">
//                       <span className="itemKey">Total Marks: </span>
//                       <span className="itemValue">
//                         {examination?.data.total_marks}
//                       </span>
//                     </div>
//                     <div className="detailItem">
//                       <span className="itemKey">Invigilator: </span>
//                       <span className="itemValue">
//                         {examination?.data.user_names}
//                       </span>
//                     </div>
//                     <div className="detailItem">
//                       <span className="itemKey">Duration: </span>
//                       <span className="itemValue">
//                         {examination?.data.duration}
//                       </span>
//                     </div>
//                     <div className="detailItem">
//                       <span className="itemKey">Scheduled Start Time: </span>
//                       <span className="itemValue">
//                         {examination?.data.schedule_start_time}
//                       </span>
//                     </div>
//                     <div className="detailItem">
//                       <span className="itemKey">Scheduled End Time: </span>
//                       <span className="itemValue">
//                         {examination?.data.schedule_end_time}
//                       </span>
//                     </div>
//                     <div className="detailItem">
//                       <span className="itemKey">Start Time: </span>
//                       <span className="itemValue">
//                         {examination?.data.start_time}
//                       </span>
//                     </div>
//                     <div className="detailItem">
//                       <span className="itemKey">End Time: </span>
//                       <span className="itemValue">
//                         {examination?.data.end_time}
//                       </span>
//                     </div>
//                     <div className="detailItem">
//                       <span className="itemKey">Checking Status: </span>
//                       <span className="itemValue">
//                         {examination?.data.checking_status}
//                       </span>
//                     </div>
//                     {/* <div className="detailItem">
//                                             <span className="itemKey">Status: </span>
//                                             <span className="itemValue">{examination?.data.status}</span>
//                                         </div> */}
//                   </div>
//                 </div>
//               </div>
//             </div>
//             {/* <div className="right">
//                     <Chart aspect={3 / 1} title="User Spending ( Last 6 Months)" />
//                 </div> */}
//           </div>
//           {/* <div className="bottom">
//                 <h1 className="title">Last Transactions</h1>
//                 <List />
//                 </div> */}
//         </div>
//       )}
//     </>
//   );
// };

// export default ExaminationSingle;
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { serverUrl } from "../../temp";

const ExaminationSingle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const examinationId = location.pathname.match(/\/examinations\/(\d+)/)?.[1];
  const [examination, setExamination] = useState(null);
  const [token] = useState(localStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

  const redirectToLogin = () => {
    alert("Please login first to access this page...");
    window.location.href = "/";
  };

  const fetchExamination = async () => {
    try {
      const response = await fetch(`${serverUrl}/examination/${examinationId}`);
      const data = await response.json();
      setExamination(data);
      localStorage.setItem("UserData", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const isPdf = (url) => {
    return url?.toLowerCase().endsWith(".pdf");
  };

  const handleImageError = () => {
    setImageError(true);
  };

  useEffect(() => {
    if (examinationId) {
      fetchExamination();
    }
  }, [examinationId]);

  if (!token) {
    redirectToLogin();
    return null;
  }

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={() => navigate(-1)}
                className="px-3 py-1 text-sm bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-all border border-purple-200 flex items-center gap-1 shadow-sm hover:shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Back
              </button>
              <h1 className="title flex-1 text-center">Exam Information</h1>
              <div className="w-20"></div>
            </div>

            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
              </div>
            ) : (
              <div className="space-y-6">
                {/* Exam Header */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
                    {/* Exam Paper Icon/Image */}
                    <div className="flex-shrink-0">
                      {isPdf(examination?.data.file_url) ? (
                        <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-purple-100 flex items-center justify-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-10 w-10 text-purple-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                            />
                          </svg>
                        </div>
                      ) : examination?.data.file_url && !imageError ? (
                        <img
                          src={examination.data.file_url}
                          alt="Paper Image"
                          className="w-20 h-20 md:w-24 md:h-24 rounded-full object-cover border-4 border-purple-100"
                          onError={handleImageError}
                        />
                      ) : (
                        <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-purple-100 flex items-center justify-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-10 w-10 text-purple-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                            />
                          </svg>
                        </div>
                      )}
                    </div>

                    {/* Exam Basic Info */}
                    <div className="flex-1 text-center md:text-left">
                      <h1 className="text-2xl font-bold text-gray-800 mb-3">
                        {examination?.data.file}
                      </h1>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                        {examination?.data.class_names && (
                          <div className="bg-gray-50 rounded-lg p-3">
                            <span className="text-gray-500 block">Class:</span>
                            <span className="font-medium">
                              {examination.data.class_names}
                            </span>
                          </div>
                        )}

                        {examination?.data.subject_names && (
                          <div className="bg-gray-50 rounded-lg p-3">
                            <span className="text-gray-500 block">
                              Subject:
                            </span>
                            <span className="font-medium">
                              {examination.data.subject_names}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Exam Details */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                    Exam Details
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Left Column */}
                    <div className="space-y-4">
                      {examination?.data.type && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Paper Type
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {examination.data.type}
                          </p>
                        </div>
                      )}

                      {examination?.data.month && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Month
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {examination.data.month}
                          </p>
                        </div>
                      )}

                      {examination?.data.date && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Date
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {examination.data.date}
                          </p>
                        </div>
                      )}

                      {examination?.data.total_marks && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Total Marks
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {examination.data.total_marks}
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Right Column */}
                    <div className="space-y-4">
                      {examination?.data.user_names && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Invigilator
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {examination.data.user_names}
                          </p>
                        </div>
                      )}

                      {examination?.data.duration && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Duration
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {examination.data.duration}
                          </p>
                        </div>
                      )}

                      {examination?.data.schedule_start_time && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Scheduled Start
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {examination.data.schedule_start_time}
                          </p>
                        </div>
                      )}

                      {examination?.data.schedule_end_time && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Scheduled End
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {examination.data.schedule_end_time}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Timing Information */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                    Actual Timing
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {examination?.data.start_time && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">
                          Start Time
                        </label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {examination.data.start_time}
                        </p>
                      </div>
                    )}

                    {examination?.data.end_time && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">
                          End Time
                        </label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {examination.data.end_time}
                        </p>
                      </div>
                    )}

                    {examination?.data.checking_status && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">
                          Checking Status
                        </label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {examination.data.checking_status}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExaminationSingle;
